import {Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';
import {EntityService} from "../../../core/entity.service";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {GlobalValidator} from "../../../shared/validators/global-validator";

@Component({
  selector: 'nuc-attribute-row',
  templateUrl: './attribute-row.component.html',
  styleUrls: ['./attribute-row.component.scss']
})
export class AttributeRowComponent implements OnInit {
  @Input() attribute;
  @Input() index;
  @Input() attributeList;
  @Input() isMobileApp;
  @Output() copy: EventEmitter<any> = new EventEmitter<any>();
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectAttribute: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;

  formErrors = {
    name: '',
    datatype: '',
    precision: '',
    required: '',
    unit: ''
  };
  validationMessages = {
    'name': {
      'required': 'VALIDATIONS.LOCATION.NAME.REQUIRED',
      'maxlength': 'VALIDATIONS.LOCATION.NAME.MAX_LENGTH',
      'jsonKey': 'VALIDATIONS.LOCATION.NAME.NO_SPECIAL_CHARACTERS',
    },
    'datatype': {
      'required': 'VALIDATIONS.LOCATION.DATA_TYPE.REQUIRED'
    },
    'precision': {
      'invalidRange': 'VALIDATIONS.LOCATION.PRECISION.NUMERIC',
    },
    'unit': {
      'required': 'VALIDATIONS.LOCATION.UNIT.REQUIRED',
      'maxlength': 'VALIDATIONS.LOCATION.UNIT.MAX_LENGTH',
      'consecutiveSpace': 'CMN_VALIDATIONS.CONSECUTIVE_SPACE',
      'minlength': 'CMN_VALIDATIONS.MIN_LENGTH_TWO',
      'onlySpace': 'VALIDATIONS.LOCATION.UNIT.ONE_NON_SPACE'

    }
  };

  @HostBinding('class.trow') isRow: boolean = true;
  @HostBinding('class.editMode') isEdit: boolean = false;

  constructor(private entityService: EntityService, private fb: FormBuilder) { }



  ngOnInit() {
    this.buildForm();
  }
@HostListener('dblclick', ['$event'])
  enableEditing() {
    if(this.isMobileApp) {
      return;
    }
    this.isEdit = true;
    this.form.enable();
  }

  buildForm(){
    this.form = this.fb.group({
      'name': [{value: this.attribute.name, disabled: true}, [
        Validators.required,
        Validators.maxLength(50),
        GlobalValidator.jsonKeyValidation
      ]],
      'datatype': [{value: this.attribute.datatype, disabled: true}, [
        Validators.required
      ]],
      'precision': [{value: this.attribute.precision, disabled: true}, [
        GlobalValidator.numberBetween(0, 100)
      ]],
      'required': [{value: this.attribute.required, disabled: true}, [
        Validators.required
      ]],
      'unit': [{value: this.attribute.unit, disabled: true}, [
        Validators.required
      ]]
    });
    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }

  onValueChanged(data?: any){
    if (!this.form) { return; }
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  discardEditing() {
    this.isEdit = false;
    this.form.reset(this.attribute);
    this.form.disable();
  }
  copyAttribute() {
    if(this.isMobileApp) {
      return;
    }
    this.copy.emit({attribute: this.attribute, index: this.index});
  }
  selectRow(select) {
    this.selectAttribute.emit({isSelect: select.checked, attribute: this.attribute });
  }

  saveAttribute(form) {
    if(!form.valid) {
      return;
    }
  if(this.isDuplicateName(form.controls.name.value)) {
     this.formErrors.name = 'VALIDATIONS.LOCATION.NAME.ALREADY_ADDED';
      return;
   }
    this.save.emit({attribute: form.value, index: this.index});
    this.attribute = form.value;
    this.isEdit = false;
    this.form.disable();
  }

  private isDuplicateName(name): boolean {
    return this.attributeList.filter((item) => item.name === name).length > 0
      && this.index !== this.attributeList.findIndex((item) => item.name === name);
  }



}



// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/attribute-row/attribute-row.component.ts